const FEE_FIXED_AMOUNT = 0.5;
const FEE_PERCENTAGE = 0.02;
const ALLOWED_PRICE_CENT_ENDINGS = [0, 25, 75];
const PRICE_OVERRIDES_BY_ADJUSTED_PRICE: Record<number, number> = {
  1.75: 1.5,
  2.75: 2.5,
  3.75: 3.5,
  7.75: 8,
};

interface PriceableProduct {
  name: string;
  price: number;
  product_type?: string;
}

const isStoreFrontArticulatedKeychain = (product: PriceableProduct): boolean => {
  return product.product_type === 'StoreFront' && /^Articulated .* Keychain$/.test(product.name);
};

const STORE_FRONT_PRICE_OVERRIDES_BY_NAME: Record<string, number> = {
  'Bottled Water with Flavoring': 2.75,
  'Loofah - Small': 4.5,
  'Loofah - Large': 10.25,
};

const getStoreFrontProductPriceOverride = (product: PriceableProduct): number | undefined => {
  if (product.product_type !== 'StoreFront') {
    return undefined;
  }

  return STORE_FRONT_PRICE_OVERRIDES_BY_NAME[product.name];
};

export const calculateFeeInclusivePrice = (price: number): number => {
  if (price <= 0) {
    return 0;
  }

  const feeInclusiveCents = Math.ceil((price + FEE_FIXED_AMOUNT + price * FEE_PERCENTAGE) * 100);
  const dollars = Math.floor(feeInclusiveCents / 100);
  const cents = feeInclusiveCents % 100;

  const roundedCents = ALLOWED_PRICE_CENT_ENDINGS.find(ending => cents <= ending);
  const roundedPrice = roundedCents !== undefined ? dollars + roundedCents / 100 : dollars + 1;

  return PRICE_OVERRIDES_BY_ADJUSTED_PRICE[roundedPrice] ?? roundedPrice;
};

export const calculateProductPrice = (product: PriceableProduct): number => {
  const storeFrontPriceOverride = getStoreFrontProductPriceOverride(product);
  if (storeFrontPriceOverride !== undefined) {
    return storeFrontPriceOverride;
  }

  if (isStoreFrontArticulatedKeychain(product)) {
    return 4.5;
  }

  return calculateFeeInclusivePrice(product.price);
};

export const migrateCartItemPrice = (
  item: PriceableProduct,
  fromPriceModelVersion: string | null,
): number => {
  const storeFrontPriceOverride = getStoreFrontProductPriceOverride(item);
  if (storeFrontPriceOverride !== undefined) {
    return storeFrontPriceOverride;
  }

  if (isStoreFrontArticulatedKeychain(item)) {
    return 4.5;
  }

  if (fromPriceModelVersion) {
    return item.price;
  }

  return calculateFeeInclusivePrice(item.price);
};
